import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isMultiple", "allowClear", "states", "placeholder"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Select, Space, Tooltip } from 'antd';
import { TaskStateColorDark } from 'core/interfaces/variables.types';
import { TaskState } from 'core/modules/tasks/task.interface';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { TaskStateIcon } from '../../types/task.types';
import { sanitizeAll } from '../../utils/sanitize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Renders a select to select a state. */
export var TaskStateSelect = function TaskStateSelect(_ref) {
  var isMultiple = _ref.isMultiple,
      allowClear = _ref.allowClear,
      states = _ref.states,
      placeholder = _ref.placeholder,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var activeStates = states !== null && states !== void 0 ? states : Object.values(TaskState);
  return /*#__PURE__*/_jsx(Container, _objectSpread(_objectSpread({}, props), {}, {
    mode: isMultiple ? 'multiple' : undefined,
    allowClear: allowClear,
    placeholder: placeholder,
    tagRender: function tagRender(item) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: t("tasks.state.".concat(item.value)),
        children: /*#__PURE__*/_jsx("span", {
          className: "tag state-".concat(item.value),
          children: TaskStateIcon[item.value]
        })
      });
    },
    showSearch: true,
    filterOption: function filterOption(input, option) {
      return sanitizeAll(option.title).includes(sanitizeAll(input));
    },
    children: activeStates.map(function (state) {
      return /*#__PURE__*/_jsx(Select.Option, {
        value: state,
        title: t("tasks.state.".concat(state)),
        children: /*#__PURE__*/_jsxs(OptionContent, {
          size: "small",
          className: state,
          children: [/*#__PURE__*/_jsx("span", {
            className: "icon",
            children: TaskStateIcon[state]
          }), /*#__PURE__*/_jsx("span", {
            className: "label",
            children: t("tasks.state.".concat(state))
          })]
        })
      }, state);
    })
  }));
}; // Styles

var Container = styled(Select).withConfig({
  displayName: "TaskStateSelect__Container",
  componentId: "sc-13gjlge-0"
})([".tag{margin-right:6px;.anticon{font-size:20px;padding-top:4px;}}", ""], Object.values(TaskState).map(function (state) {
  return css([".tag.state-", "{.anticon{color:", ";}}"], state, TaskStateColorDark[state]);
}));
var OptionContent = styled(Space).withConfig({
  displayName: "TaskStateSelect__OptionContent",
  componentId: "sc-13gjlge-1"
})(["", ""], Object.values(TaskState).map(function (state) {
  return css(["&.", "{.anticon,.label{color:", ";}}"], state, TaskStateColorDark[state]);
}));